import { render, staticRenderFns } from "./ManageBlog.vue?vue&type=template&id=2c7dd510&scoped=true"
import script from "./ManageBlog.vue?vue&type=script&lang=js"
export * from "./ManageBlog.vue?vue&type=script&lang=js"
import style0 from "./ManageBlog.vue?vue&type=style&index=0&id=2c7dd510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7dd510",
  null
  
)

export default component.exports